import { render, staticRenderFns } from "./vfg-vsdatepicker.vue?vue&type=template&id=2e182f73"
import script from "./vfg-vsdatepicker.vue?vue&type=script&lang=js"
export * from "./vfg-vsdatepicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports